import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AlertController, LoadingController } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';
import { ReportService } from '../../services/report.service';
import { UserService } from '../../services/user.service';
import { Stylist } from '../../models/stylist/stylist.model';
import { Utilities } from '../../utilities/utilities';
import { SMPickerRange } from '../../components/smr-date-picker/smr-date-picker.component';
import { StylistPickerComponent } from '../../components/stylist-picker/stylist-picker.component';
import { switchMap } from 'rxjs/operators';
// import { GoogleAnalytics } from '@awesome-cordova-plugins/google-analytics';
import { SalonMonsterCurrencyPipe } from '../../pipes/salonmonster-currency.pipe';
import { ExportTableService } from '../../services/export-table.service';
import { CalendarService } from '../../services/calendar.service';
import { ChartsService } from '../../services/charts.service';
import { Router } from '@angular/router';

import { ChartConfiguration, ChartType, ChartTypeRegistry } from 'chart.js';

declare var Chart: any;
interface primeNgCol {
  field: string;
  header: string;
}
type MyChartTypeRegistry = {
  bar: ChartType;
  line: ChartType;
  radar: ChartType;
  // ... other chart types
};
@Component({
  selector: 'smr-sales-report',
  templateUrl: './sales-report.page.html',
  styleUrls: ['./sales-report.page.scss'],
  providers: [SalonMonsterCurrencyPipe],
})
export class SalesReportPage implements OnInit {
  //@ViewChild(Content) content: Content;

  @ViewChild(StylistPickerComponent)
  stylistPickerComponent: StylistPickerComponent;

  // src: https://github.com/valor-software/ng2-charts/issues/776
  //@ViewChild(BaseChartDirective) pieChartInstance: BaseChartDirective;

  public stylistBreakdown: Array<any>;
  public slideConfig = {
    effect: 'flip',
    slidesPerView: 1,
    centeredSlides: true,
    autoHeight: true
  };

  public barChartOptionsCustomersByTime: ChartConfiguration<'bar'>['options'];

  public staffBreakdownStats: Array<any>;

  public cols: primeNgCol[];

  public radarChartType: keyof MyChartTypeRegistry = 'radar';

  public colsAvg: primeNgCol[];
  public colsStaffBreakdown: primeNgCol[];


  public exportFile: any[];

  public barChartLabels: string[] = [];

  public barChartType: keyof MyChartTypeRegistry = 'bar';


  public barChartLegend: boolean = true;

  public yearIndicator: boolean = false;

  public xAxisDateChanger: string;

  public stats: Array<any>;

  public graph: object;

  public yearTotalWeekData: any[] = [];

  private tooltipCallbacks: object = {
    title: (point) => {
      return (
        'Week of ' +
        Utilities.formatDate(
          Utilities.parseDate(point[0].xLabel),
          'ddd, MMM Do YYYY'
        )
      );
    },
    label: (tooltipItem, data) => {
      return (
        data.datasets[tooltipItem.datasetIndex].label +
        ' Daily Avg' +
        ': ' +
        tooltipItem.yLabel +
        Utilities.decodeHtml(this.userService.getSalon().getCurrency())
      );
    },
    afterLabel: (tooltipItem, data) => {
      if (data.datasets[tooltipItem.datasetIndex].label === 'Retail')
        return (
          'Week Retail Total: ' +
          this.yearTotalWeekData[tooltipItem.index].sumRetail +
          Utilities.decodeHtml(this.userService.getSalon().getCurrency())
        );
      else
        return (
          'Week Services Total: ' +
          this.yearTotalWeekData[tooltipItem.index].sumService +
          Utilities.decodeHtml(this.userService.getSalon().getCurrency())
        );
    },
  };
  // =============================================Testing Charts=============================================
  public radarChartOptions: ChartConfiguration<'radar'>['options'];

  public radarChartLabels: string[] = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];

  public radarChartData: ChartConfiguration<'radar'>['data'] = {
    labels: this.radarChartLabels,
    datasets: [
      {
        data: [],
        label: 'Customers by day',
        borderColor: '#5a87c7',
        backgroundColor: '#5a87c720',
      },
    ],
  };

  public barChartLabelsCustomersByTime: string[] = [
    '7-9am',
    '9-11am',
    '11-1pm',
    '1-3pm',
    '3-5pm',
    '5-7pm',
    '7-9pm',
    '9-11pm',
  ];

  public barChartTypeCustomersByTime: keyof MyChartTypeRegistry = 'bar';

  public barChartDataCustomersByTime: ChartConfiguration<'bar'>['data'] = {
    labels: this.barChartLabelsCustomersByTime,
    datasets: [
      {
        data: [0, 0, 0, 0, 0, 0, 0, 0],
        label: 'Customers by time of day',
        borderColor: '#82625180',
        backgroundColor: '#82625180',
      },
    ],
  };

  public barChartColorsCustomersByTime: Array<any>;

  public barChartData: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: 'Retail',
        borderColor: '#32abda80',
        backgroundColor: '#32abda80',
      },
      {
        data: [],
        label: 'Services',
        borderColor: '#fed4a480',
        backgroundColor: '#fed4a480',
      },
    ],
  };

  public barChartOptions: ChartConfiguration<'bar'>['options'];

  public barChartLabelsMain: Array<any> = [];

  public barChartOptionsMain: any;

  public tab: string;

  public stylistID: number;

  public stylist: Stylist;

  public readOnlyStylistPicker: boolean;

  public isLoading: boolean;

  public errorOccurredWhileLoadingStylistPicker: boolean;

  public errorOccurredWhileLoadingStats: boolean;

  public startDate: Date;

  public endDate: Date;

  public groupBy: string;

  public salesTotal: number;

  constructor(
    //public navCtrl: NavController,
    //public navParams: NavParams,
    private router: Router,
    public reportService: ReportService,
    public userService: UserService,
    public alertController: AlertController,
    private salonMonsterCurrencyPipe: SalonMonsterCurrencyPipe,
    public loadingCtrl: LoadingController,
    private ExportTableService: ExportTableService,
    private CalendarService: CalendarService,
    private ChartsService: ChartsService // private googleAnalytics: GoogleAnalytics,
  ) {
    const currency = this.userService.getSalon().getCurrency();
    this.stats = [];
    this.stylistBreakdown = [];
    this.tab = 'totals';
    this.xAxisDateChanger = 'week';
    this.cols = [
      { field: 'timestamp', header: 'Date' },
      { field: 'serviceTotal', header: 'Services' },
      { field: 'retailTotal', header: 'Retail' },
      { field: 'salesPreTaxTotal', header: 'Pre-tax' },
      { field: 'taxesTotal', header: 'Taxes' },
      { field: 'salesTotal', header: 'Total' },
      { field: 'tipsTotal', header: 'Tips' },
    ];
    this.colsAvg = [
      { field: 'timestamp', header: 'Date' },
      { field: 'serviceAverage', header: 'Avg Service' },
      { field: 'retailAverage', header: 'Avg Retail' },
      { field: 'salesAverage', header: 'Avg Total' },
      { field: 'tipsAverage', header: 'Avg Tips' },
    ];
    this.colsStaffBreakdown = [
      { field: 'stylistFullName', header: "Staff member" },
      { field: 'serviceTotal', header: "Services" },
      { field: 'retailTotal', header: "Retail" },
      { field: 'salesPreTaxTotal', header: "Pre-tax" },
      { field: 'taxesTotal', header: "Taxes" },
      { field: 'salesTotal', header: "Total" },
      { field: 'tipsTotal', header: "Tips" }
    ];

    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      this.stylistID = user.getID();
      this.readOnlyStylistPicker = !(
        user.isAdministrator() || user.getCanViewReports() === 1
      );
    }
    this.barChartOptionsMain = ChartsService.lineChartOption(
      this.yearTotalWeekData,
      this.xAxisDateChanger
    );
    this.barChartOptionsMain.scales.yAxes = [
      {
        ticks: {
          callback: function (value, index, values) {
            return Utilities.decodeHTML(currency) + value;
          },
        },
      },
    ];

    this.barChartOptionsCustomersByTime = {
      plugins: {
        title: {
          display: true,
          position: 'bottom',
          text: 'Number of customers in one day',
        },
      },
    };

    // ChartsService.barChartOption(
    //   'Number of customers in one day',
    //   'top'
    // );
    this.radarChartOptions = ChartsService.radarChartOption();
    this.isLoading = true;
  }

  public ngOnInit() {
    if (!this.startDate) {
      let dateFromCache: string = localStorage.getItem('datePickerStartDate');

      if (dateFromCache && Utilities.parseDate(dateFromCache)) {
        this.startDate = Utilities.parseDate(dateFromCache);
      }
    }

    if (!this.endDate) {
      let dateFromCache: string = localStorage.getItem('datePickerEndDate');

      if (dateFromCache && Utilities.parseDate(dateFromCache)) {
        this.endDate = Utilities.parseDate(dateFromCache);
      }
    }
    if (!this.groupBy) {
      let dateFromCache: string = localStorage.getItem('groupBy');

      if (dateFromCache) {
        this.groupBy = dateFromCache;
      } else {
        this.groupBy = 'daily';
      }
    }

    const currency = this.userService.getSalon().getCurrency();
    this.barChartOptions = {
      scales: {
        x: {
          stacked: true,
        },
        y: {
          stacked: true,
          ticks: {
            callback: function (value, index, values) {
              return Utilities.decodeHTML(currency) + value;
            },
          },
        },
      },
      plugins: {
        tooltip: {
          callbacks: {
            label: (context) => {
              return (
                context.dataset.label +
                ': ' +
                context.parsed.y +
                Utilities.decodeHtml(this.userService.getSalon().getCurrency())
              );
            },
          }
        }
      }

    }
  }


  public onStylistPickerInit(initResponse: {
    success: boolean;
    stylist: Stylist;
  }) {
    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
    } else {
      this.isLoading = false;
      this.errorOccurredWhileLoadingStylistPicker = true;
    }
  }

  public onStylistSelect(stylist: Stylist) {
    this.isLoading = false;
    if (stylist) {
      this.stylistID = stylist.getID();
      this.stylist = stylist;
      this.loadStats(stylist, this.startDate, this.endDate, this.groupBy);
    }
  }

  public onTapToReload() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingStylistPicker = false;
    this.errorOccurredWhileLoadingStats = false;
    this.stylistPickerComponent.ngOnInit();
  }

  public rangeChanged(dateRange: SMPickerRange) {
    this.startDate = dateRange.start;
    this.endDate = dateRange.end;
    this.groupBy = dateRange.groupBy;

    this.timeManager(dateRange.start, dateRange.end, this.groupBy);
    this.loadStats(this.stylist, this.startDate, this.endDate, this.groupBy);
  }

  public timeManager(dateRangeStart, dateRangeEnd, groupBy) {
    let resObj = this.CalendarService.timeManager(dateRangeStart, dateRangeEnd);
    this.xAxisDateChanger = resObj.xAxisDateChanger;
    this.yearIndicator = resObj.yearIndicator;

    this.barChartOptionsMain.scales.xAxes[0].time.unit = this.xAxisDateChanger;
    this.barChartOptionsMain.scales.xAxes[0].time.displayFormats =
      ChartsService.timeDisplayFormat();
    if (this.yearIndicator && groupBy === 'daily') {
      this.barChartOptionsMain.tooltips.callbacks = this.tooltipCallbacks;
    } else {
      this.barChartOptionsMain.tooltips.callbacks = {};
    }
  }

  public summaryTotalCol(cells: any[]) {
    let colTotal = cells.reduce((sum, cell) => (sum += cell));
    return colTotal;
  }

  public summaryServicesCol() {
    return this.stats
      .map((row) => row['serviceTotal'])
      .reduce((res, cell) => (res += cell), 0);
  }

  public summaryRetailCol() {
    return this.stats
      .map((row) => row['retailTotal'])
      .reduce((res, cell) => (res += cell), 0);
  }

  public summaryPreTaxCol() {
    return this.stats
      .map((row) => row['salesPreTaxTotal'])
      .reduce((res, cell) => (res += cell), 0);
  }

  public summaryTaxesCol() {
    return this.stats
      .map((row) => row['taxesTotal'])
      .reduce((res, cell) => (res += cell), 0);
  }

  public summarySalesCol() {
    return this.stats
      .map((row) => row['salesTotal'])
      .reduce((res, cell) => (res += cell), 0);
  }

  public summaryTipsCol() {
    return this.stats
      .map((row) => row['tipsTotal'])
      .reduce((res, cell) => (res += cell), 0);
  }

  public loadStats(
    stylist: Stylist,
    startDate: Date,
    endDate: Date,
    groupBy: string = 'daily'
  ) {
    this.timeManager(startDate, endDate, groupBy);
    this.isLoading = true;
    this.errorOccurredWhileLoadingStats = false;
    this.barChartLabels = [];

    this.reportService
      .loadSalesStats(stylist.id, startDate, endDate, groupBy, true)
      .pipe(
        switchMap(() => {
          return this.reportService.loadSalesStats(
            stylist.id,
            startDate,
            endDate,
            groupBy
          );
        })
      )
      .subscribe({
        next: ({ graph, stats }) => {
          this.stats = stats.toArray();
          let barChartDataCustomersByTimeDataSets = [];
          let radarChartDataSets = [];

          for (let day in graph.customersByTime) {
            barChartDataCustomersByTimeDataSets.push(
              graph.customersByTime[day]
            );
          }
          for (let hour in graph.customersByDay) {
            radarChartDataSets.push(graph.customersByDay[hour]);
          }
          this.barChartDataCustomersByTime.datasets[0].data =
            barChartDataCustomersByTimeDataSets;
          this.radarChartData.datasets[0].data = radarChartDataSets;
          let totalServices: number = 0;
          let totalRetail: number = 0;
          let serviceSeries = {
            data: [],
            label: 'Services',
            borderColor: '#32abda',
            backgroundColor: '#32abda',
          };
          let retailSeries = {
            data: [],
            label: 'Retail',
            orderColor: '#fed4a4',
            backgroundColor: '#fed4a4',
          };
          let barChartLabelsMain: string[] = [];

          this.stats.forEach((row) => {
            barChartLabelsMain.push(row.timestamp);
            row.timestamp = Utilities.formatDate(
              Utilities.parseDate(row.timestamp),
              'YY MMM D ddd'
            );
            totalServices += Number(row.serviceTotal.toFixed(2));
            totalRetail += row.retailTotal;

            serviceSeries.data.push(row.serviceTotal);
            retailSeries.data.push(row.retailTotal.toFixed(2));
          });

          this.salesTotal = totalServices + totalRetail;

          if (this.yearIndicator && groupBy === 'daily') {
            // this.barChartData.datasets = [];
            this.barChartLabelsMain = barChartLabelsMain.filter((label, i) => {
              return (i % 7 === 1 && i !== 1) || i === 0;
            });
            let dataSumRetail: number = 0,
              dataSumServiceSeries: number = 0,
              count: number = 0,
              retailData = [],
              serviceData = [];

            for (let i = 0; i < retailSeries.data.length; i++) {
              if (
                (i !== 1 && i % 7 === 1) ||
                i === retailSeries.data.length - 1
              ) {
                retailData.push(Number((dataSumRetail / count).toFixed(2)));
                serviceData.push(
                  Number((dataSumServiceSeries / count).toFixed(2))
                );
                this.yearTotalWeekData.push({
                  sumRetail: Number((dataSumRetail / count).toFixed(2)),
                  sumService: Number((dataSumServiceSeries / count).toFixed(2)),
                });

                count = 0;
                dataSumRetail = 0;
                dataSumServiceSeries = 0;
              } else {
                dataSumRetail += Number(retailSeries.data[i]);
                dataSumServiceSeries += Number(serviceSeries.data[i]);
                count += 1;
              }
            }
            retailSeries.data = retailData;
            serviceSeries.data = serviceData;
          } else {
            this.yearTotalWeekData = [];
            this.barChartLabelsMain.length = 0;
            let barChartLabelsMainTemp = [];
            for (let label of barChartLabelsMain) {
              barChartLabelsMainTemp.push(label);
            }
            if (groupBy === 'weekly') {
              barChartLabelsMainTemp = barChartLabelsMainTemp.map((week) => {
                return week.substring(0, week.indexOf(' '));
              });
            }
            this.barChartLabelsMain = barChartLabelsMainTemp;
          }

          this.barChartData.labels = this.barChartLabelsMain;
          this.barChartData.datasets = [retailSeries, serviceSeries];
          this.isLoading = false;
          //this.content.resize();
          // if all staff then get stats broken down by staff member
          if (stylist.getID() === 0) {
            this.reportService.loadSalesStats(stylist.id, startDate, endDate, groupBy, true)
              .subscribe(({ stats, graph }) => {

                this.staffBreakdownStats = stats.toArray();
              });
          }
        },
        error: (e) => {
          this.isLoading = false;
          this.errorOccurredWhileLoadingStats = true;
          // this.content.resize();
        },
      });
  }

  /*public loadStats (stylist: Stylist, startDate: Date, endDate: Date, groupBy: string = 'daily') {
    this.timeManager(startDate, endDate, groupBy);
    this.isLoading = true;
    this.errorOccurredWhileLoadingStats = false;
    this.barChartLabels = [];
    this.reportService.loadSalesStats(stylist.id, startDate, endDate, groupBy, true)
      .pipe(
        switchMap(() => {
          return this.reportService.loadSalesStats(stylist.id, startDate, endDate, groupBy);
        })
      )
      .subscribe(({stats, graph}) => {
          this.stats = stats.toArray();
          let barChartDataCustomersByTime = [];
          let radarChartData = [];

          for (let day in graph.customersByTime) {
            barChartDataCustomersByTime.push(graph.customersByTime[day]);
          }
          for (let hour in graph.customersByDay) {
            radarChartData.push(graph.customersByDay[hour]);
          }
          this.barChartDataCustomersByTime[0].data = barChartDataCustomersByTime;
          this.radarChartData[0].data = radarChartData;
          let totalServices: number = 0;
          let totalRetail: number = 0;
          let serviceSeries = {data: [], label: 'Services', stack: 'a'};
          let retailSeries = {data: [], label: 'Retail', stack: 'a'};
          let barChartLabelsMain: string[] = [];

          this.stats.forEach((row) => {
            barChartLabelsMain.push(row.timestamp);
            row.timestamp = Utilities.formatDate(Utilities.parseDate(row.timestamp), 'YY MMM D ddd');
            totalServices += Number(row.serviceTotal.toFixed(2));
            totalRetail += row.retailTotal;

            serviceSeries.data.push(row.serviceTotal);
            retailSeries.data.push(row.retailTotal.toFixed(2));
          });


          // for (let dayOfWeek in graph.customersByDay ) {
          //   this.radarChartData[0].data.push(dayOfWeek);
          // }


          this.salesTotal = totalServices + totalRetail;

          if (this.yearIndicator && (groupBy === 'daily')) {
            this.barChartData[0].data = [];
            this.barChartLabelsMain = barChartLabelsMain.filter((label, i) => { return ((i%7 === 1) && (i !== 1)) || (i === 0)});
            let dataSumRetail:number = 0, dataSumServiceSeries:number = 0, count:number = 0, retailData = [], serviceData = [];

            for (let i = 0; i < retailSeries.data.length; i++) {
              if ((i !== 1 && i%7 === 1) || (i === retailSeries.data.length-1)) {
                retailData.push(Number((dataSumRetail / count).toFixed(2)));
                serviceData.push(Number((dataSumServiceSeries / count).toFixed(2)));
                this.yearTotalWeekData.push({sumRetail: Number((dataSumRetail / count).toFixed(2)), sumService: Number((dataSumServiceSeries / count).toFixed(2))});

                count = 0;
                dataSumRetail = 0;
                dataSumServiceSeries = 0;
              } else {
                dataSumRetail +=  Number(retailSeries.data[i]);
                dataSumServiceSeries += Number(serviceSeries.data[i]);
                count += 1;
              }
            }
            retailSeries.data = retailData;
            serviceSeries.data = serviceData;
          } else {
            this.yearTotalWeekData = [];
            this.barChartLabelsMain.length = 0;
            let barChartLabelsMainTemp = [];
            for (let label of barChartLabelsMain) {
              barChartLabelsMainTemp.push(label);
            }
            if (groupBy === 'weekly') {
              barChartLabelsMainTemp = barChartLabelsMainTemp.map(week => {
                return week.substring(0, week.indexOf(" "));
              })
            }
            this.barChartLabelsMain = barChartLabelsMainTemp;
          }
          this.barChartData = [
            retailSeries,
            serviceSeries
          ];
          this.isLoading = false;
         // this.content.resize();
        },
        (err) => {
          this.isLoading = false;
          this.errorOccurredWhileLoadingStats = true;
          //this.content.resize();
        });
  } */

  public exportFileSetter(type) {
    if (type === 'cols') {
      this.exportFile = [...this.stats.map(stat => { return { timestamp: stat.timestamp, serviceTotal: stat.serviceTotal, retailTotal: stat.retailTotal, salesPreTaxTotal: stat.salesPreTaxTotal, taxesTotal: stat.taxesTotal, salesTotal: stat.salesTotal, tipsTotal: stat.tipsTotal } }), { timestamp: "Total", serviceTotal: this.summaryServicesCol(), retailTotal: this.summaryRetailCol(), salesPreTaxTotal: this.summaryPreTaxCol(), taxesTotal: this.summaryTaxesCol(), salesTotal: this.summarySalesCol(), tipsTotal: this.summaryTipsCol() }]
    } else if (type === 'colsStaffBreakdown') {
      this.exportFile =
        [...this.staffBreakdownStats.map(stat => {
          return {
            stylistFullName: stat.stylistFullName,
            serviceTotal: stat.serviceTotal,
            retailTotal: stat.retailTotal,
            salesPreTaxTotal: stat.salesPreTaxTotal,
            taxesTotal: stat.taxesTotal,
            salesTotal: stat.salesTotal,
            tipsTotal: stat.tipsTotal
          }
        }),
        {
          stylistFullName: "Total",
          serviceTotal: this.summaryServicesCol(),
          retailTotal: this.summaryRetailCol(),
          salesPreTaxTotal: this.summaryPreTaxCol(),
          taxesTotal: this.summaryTaxesCol(),
          salesTotal: this.summarySalesCol(),
          tipsTotal: this.summaryTipsCol()
        }]
    } else {
      this.exportFile = [...this.stats.map(stat => { return { timestamp: stat.timestamp, serviceAverage: stat.serviceAverage, retailAverage: stat.retailAverage, salesAverage: stat.salesAverage, tipsAverage: stat.tipsAverage } })]
    }
  }

  public exportPdf(type) {
    this.exportFileSetter(type);
    this.ExportTableService.exportPdf(this.exportFile, 'Sales', this[type]);
  }

  public exportExcel(type) {
    this.exportFileSetter(type);
    this.ExportTableService.exportExcel(
      this.exportFile,
      'Sales',
      this[type].map((col) => col.header)
    );
  }

  public onBack() {
    //this.router.navigateBack('/reports');
  }
}
